import React, { forwardRef, useImperativeHandle, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const SITE_KEY = "6LfFQRwqAAAAAGicM3Ug910qi17m1XNUcQqkSwnY";

const CaptchaField = forwardRef(({ onChange }, ref) => {
  const internalRef = useRef();

  useImperativeHandle(ref, () => ({
    reset: () => {
      if (internalRef.current) {
        internalRef.current.reset();
      }
    },
    execute: () => {
      if (internalRef.current) {
        internalRef.current.execute();
      }
    },
    getValue: () => {
      if (internalRef.current) {
        return internalRef.current.getValue();
      }
      return null;
    },
  }));

  return (
    <div>
      <ReCAPTCHA
        ref={internalRef}
        sitekey={SITE_KEY}
        onChange={onChange}
        hl="id"
      />
    </div>
  );
});

export default CaptchaField;
